import React, { useContext } from "react";
import { AppContext } from "../../App";
import Can from "../can/Can";
import { fee } from "../../rbac-consts";
import { default as AdminRateDetailsContainer } from "./admin/rates/RateDetailsContainer";

const ClientsRateWrapper = ({ match }) => {

  const { user } = useContext(AppContext);

  return (
    <Can
      role={user.roles}
      perform={fee.ADMIN}
      yes={() => (
        <AdminRateDetailsContainer match={match} />
      )}
    />
  );
};

export default ClientsRateWrapper;